import { UserLoginType } from "@/DTO";
import { Api } from "@/api";

export const update = (user: UserLoginType, id: string, name: string) => {
  return new Promise<{}>((resolve, reject) => {
    const api = new Api({
      method: "patch",
      path: `category/${id}`,
      header: {
        Authorization: "Bearer " + user?.accessToken,
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        name: name
      })
    });
    return api
      .call()
      .then((data) => {
        return resolve({
          data
        });
      })
      .catch((err) => {
        return reject(err);
      });
  });
};
